import { Injectable, inject } from '@angular/core';
import { AccountService } from '@visiativ/digital-account-front';
import { UikSubNavigationBuilder, UikSubNavigationConfiguration } from '@visiativ/uik-am';

@Injectable({
	providedIn: 'root',
})
export class AppSubNavigationService {
	public accountService = inject(AccountService);

	private readonly hasCustomerId: () => boolean = () => {
		const token = this.accountService.tokenStoredUserSubject.value;
		return !!token?.customerId && !!token?.idContactSalesforce;
	};

	configureHelpdeskComponentsSubNavigation(): UikSubNavigationConfiguration {
		return new UikSubNavigationBuilder()
			.setTitle($localize`:@@hub.global.client-service-label:Service client`)

			.addRoute(
				$localize`:@@hub.global.helpdesk-label:Mes demandes d'assistance`,
				'/helpdesk/tickets',
				{
					condition: () => this.hasCustomerId(),
				},
			)
			.addRoute(
				$localize`:@@hub.global.helpdesk-label:Mes demandes d'assistance`,
				'/helpdesk/support',
				{
					condition: () => !this.hasCustomerId(),
				},
			)
			.addRoute($localize`:@@hub.global.flexo-project-label:Projets Flexo`, '/projects/flexo', {
				condition: this.hasCustomerId,
			})
			.addRoute(
				$localize`:@@hub.global.flexo-project-label:Projets Flexo`,
				'/projects/flexo/support',
				{
					condition: () => !this.hasCustomerId(),
				},
			)
			.addRoute(
				$localize`:@@hub.global.download-center-label:Centre de téléchargement`,
				'/download-center',
			)

			.build();
	}

	configureCompanyComponentsSubNavigation(): UikSubNavigationConfiguration {
		return new UikSubNavigationBuilder()
			.setTitle($localize`:@@hub.global.my-company-label:Ma société`)

			.addRoute(
				$localize`:@@hub.global.company-information-label:Informations société`,
				'/my_company',
			)
			.addRoute($localize`:@@hub.global.users-label:Utilisateurs`, '/users')
			.addRoute($localize`:@@hub.global.licences-label:Licences`, '/licences')
			.addRoute($localize`:@@hub.global.contracts-label:Contrats`, '/contracts')

			.build();
	}

	configureTrainingComponentsSubNavigation(): UikSubNavigationConfiguration {
		return new UikSubNavigationBuilder()
			.setTitle($localize`:@@hub.global.training-center-label:Centre de formation`)

			.addRoute(
				$localize`:@@hub.global.training-catalog-label:Toutes les formations`,
				'/training/catalog',
			)
			.addRoute(
				$localize`:@@hub.global.training-calendar-label:Calendrier des formations`,
				'/training/calendar',
			)
			.addRoute($localize`:@@hub.global.training-my-sessions-label:Mes sessions`, '/my-sessions')

			.build();
	}
}
